<template>
  <div v-if="visivel" class="w3-modal" style="display: block;">
    <div class="w3-container w3-modal-content w3-animate-zoom">

      <header class="w3-row-padding">
        <span @click="fechar()" class="w3-button w3-display-topright">&times;</span>
        <h4 class="texto-vermelho titulo">Pesquisar CEP</h4>
      </header>

      <div
        v-show="mostrar_filtros"
        class="w3-row-padding w3-margin-bottom">

        <div
          class="w3-left w3-padding-left w3-col"
          style="padding: 0;">

          <div class="w3-col s12 m6 l6">
            <frame-bairro
              ref="frBairro"
              somenteLeitura="N"
              @confirmar="confirmarBairro">
            </frame-bairro>
          </div>

          <div class="w3-col s12 m6 l6">
            <frame-cidade
              ref="frCidade"
              somenteLeitura="N">
            </frame-cidade>
          </div>

          <div class="w3-col">
            <label>Logradouro</label>
            <input 
              type="text"
              ref="campoPesquisa"
              id="campoPesquisa"
              autocomplete="off"
              v-model="logradouro"
              v-on:keyup="converter()"
              placeholder="busca avançada"
              v-on:keyup.enter="pesquisar(false)"
              :class="buscarClasseCampoPesquisa()"
              style="max-width: 100%; border-radius:4px; text-transform:uppercase" />
          </div>

          <div class="w3-col s9 m9 l9 w3-right">
            <button 
              class="w3-button w3-theme w3-right" 
              style="margin-top: 21px;" 
              @click="pesquisar(false)"
              :disabled="processando">
              <span>Pesquisar</span>
            </button>                  
          </div>

        </div>
      </div>

      <div v-if="processando" class="w3-col s12 m12 l12">
        <div class="w3-panel w3-theme w3-card-2">
          <p>
            <i class="fa fa-sync-alt w3-spin"></i>
            <span> Processando...</span>
          </p>
        </div>
      </div>
            
      <div
        v-if="(
          mostrar_filtros &&
          (dados_filtrados.length > 0) && 
          (!processando)
        )"
        class="w3-col s12 m12 s12 w3-center">
        
        <i
          class='fas fa-caret-down' 
          @click="mostrar_filtros = false"
          style='font-size:24px; cursor: pointer;'>
        </i> 
      </div>

      <div class="w3-col s12 m12 l12 w3-left">
        <button
          class="w3-bar-item w3-button w3-col w3-white w3-border w3-mobile"
          v-if="!mostrar_filtros" v-on:click="mostrar_filtros = !mostrar_filtros">
            <i class="fa fa-filter icone-vermelho"></i>
            <span> Mostrar filtros</span>
        </button>
      </div>

      <div v-if="!mostrar_filtros">
        <div class="w3-col s12 w3-margin-top w3-margin-bottom">            
          <div
            v-show="dados_filtrados.length > 0" 
            class="w3-responsive w3-small"
            v-if="!mostrar_filtros" 
            style="max-height: calc(75vh - 300px); min-height: 200px; overflow: auto" >

            <div
              class=""
              :key="cep.cep_id"
              v-for="cep in dados_filtrados"
              @click="confirmar(cep)">

              <div
                class="w3-col card-itens w3-border w3-padding-small"
                style="cursor: pointer; white-space: normal;">

                <div class="w3-col">
                  <strong class="texto-vermelho">{{cep.cep_formatado}}</strong>
                  <span> - {{cep.logradouro}}</span>
                  <span v-if="cep.nome_bairro"> - {{cep.nome_bairro}}</span>
                  <span> - {{cep.nome_cidade}}/{{cep.estado_id}}</span>
                </div>
              </div>
            </div>
          </div>

          <div class="w3-col l12 w3-right w3-margin-top" v-if="mostrar_botao_ver_mais">
            <button 
              :disabled="processando_ver_mais"
              v-on:click="adicionarClienteVerificandoDados(true)"
              class="w3-button w3-theme w3-right">
              <span>Ver mais</span>
            </button>
          </div>
        </div>

        <footer class="w3-container conteudo-centralizado"></footer>
      </div>
    </div>
  </div>
</template>

<script>
  import toastr from 'toastr';
  import Biblioteca from '@/components/Repositorio/Biblioteca';
  import RCep from '@/components/Rest/RCep';
  import FrameCidade from '@/components/Frames/FrameCidade';
  import FrameBairro from '@/components/Frames/FrameBairro';

  export default {
    name: 'PesquisaCEPs',

    components: {
      FrameCidade,
      FrameBairro
    },

    data() {
      return {
        visivel: false,
        chave_pesquisa: '',
        indice_selecionado: 1,
        mostrar_botao_ver_mais: false,
        processando_ver_mais: false,

        logradouro: '',
        cidade_selecionada: {},
        bairro_selecionado: {},

        tipos_pesquisa: [
          {
            indice: 0,
            tipo_pesquisa: 'COD',
            descricao_pesquisa: 'Código',
            placeholder: 'Digite o código'
          },
          {
            indice: 1,
            tipo_pesquisa: 'NOM',
            descricao_pesquisa: 'Nome',
            placeholder: 'Digite o nome'
          }
        ],

        processando: false,
        mostrar_filtros: true,
        dados_filtrados: [],
        ceps_ja_mostrados_ids: []
      }
    },

    methods: {
      abrir() {
        this.visivel = true;  
        this.logradouro = '';
        this.$nextTick(() => this.$refs.campoPesquisa.focus());
      },

      confirmar(cep) {
        cep = JSON.parse(JSON.stringify(cep));
        this.$emit('confirmar', cep);
        this.visivel = false; 
      },

      confirmarBairro(bairro) {
        this.$refs.frCidade.inserirDadoPorChave(bairro.cidade_id);
      },

      fechar() {
        this.visivel = false;
      },

      converter() {
        let tipo_selecionado = this.tipos_pesquisa[this.indice_selecionado].tipo_pesquisa;
        this.chave_pesquisa = this.chave_pesquisa.toUpperCase();
      },

      verificarDados() {
        let cidade_selecionada = this.$refs.frCidade.selecao();
        let bairro_selecionado = this.$refs.frBairro.selecao();

        if (!this.logradouro)


        if ((!cidade_selecionada) && (!bairro_selecionado)) {
          if ((!this.logradouro) || (this.logradouro.trim() == '')) {
            toastr.error('Informe um logradouro válido!');
            return false;
          }
          else {
            toastr.error('Informe pelo menos um dos filtros de pesquisa!');
            return false;
          }
        }

        return true;
      },

      async pesquisar(ver_mais) {
        try {
          if (!this.verificarDados()) {
            return;
          }

          this.processando = true;
          this.dados_filtrados = [];

          let parametros = {}

          let cidade_selecionada = this.$refs.frCidade.selecao();
          if (cidade_selecionada) {
            parametros.cidade_id = cidade_selecionada.cidade_id;
          }

          let bairro_selecionado = this.$refs.frBairro.selecao();
          if (bairro_selecionado) {
            parametros.bairro_id = bairro_selecionado.bairro_id;
          }

          parametros.logradouro = this.logradouro;
          parametros.ceps_ja_mostrados_ids = this.ceps_ja_mostrados_ids;

          let retorno = await RCep.pesquisarCeps(this.axios, parametros);
          if (retorno.houve_erro != 'N') {
            throw new Error(retorno.mensagem);
          }

          this.dados_filtrados =  retorno.dados.ceps;
          this.mostrar_filtros = false;
          this.processando = false;
          this.mostrar_botao_ver_mais = retorno.dados.tem_continuacao == 'S';
          
          if (ver_mais) {
            for (let i in this.dados_filtrados) {
              this.ceps_ja_mostrados_ids.push(this.dados_filtrados[i].cep_id);
            }
          }
          else {
            this.ceps_ja_mostrados_ids = [];
          }
        }
        catch (e) {
          this.processando = false;
          toastr.error(e.message);
        }
      },
      
      adicionarClienteVerificandoDados(ver_mais) {
        for (let i in this.dados_filtrados) {
          this.ceps_ja_mostrados_ids.push(this.dados_filtrados[i].cadastro_id);
        }

        this.pesquisar(ver_mais);
      },
      
      buscarClasseCampoPesquisa() {
        let retorno = 'w3-input w3-border';

        if (!Biblioteca.stringVazia(this.chave_pesquisa)) {
          let tipo_selecionado = this.tipos_pesquisa[this.indice_selecionado].tipo_pesquisa;
          retorno = retorno + ' tudo-maiusculo';
        }

        return retorno;
      },

      nPadrao(numero, casas_decimais = 2) {
        return Biblioteca.nPadrao(numero, casas_decimais);
      }
    }
  }
</script>

<style escoped>
  .card-itens{
    border-radius: 10px 10px 10px 10px;
    box-shadow: #f3f3f3 1px 3px 5px 3px ;
    border-bottom: 0px dotted #666666;
    margin-top: 5px;
  }
  
  @media screen and (min-width: 1200px) {
    .w3-modal-content {
      width: 80%;
    }
  }

  @media screen and (max-width: 1199px) {
    .w3-modal-content {
      width: 95%;
    }
  }

  .fundo-enfase {
    background-color: #dedede;
  }

  .tudo-minusculo {
    text-transform: lowercase;
  }

  .tudo-maiusculo {
    text-transform: uppercase;
  }

</style>


// WEBPACK FOOTER //
// src/components/Pesquisas/PesquisaCEPs.vue